var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBluev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 48,
    viewBox: "0 0 133 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9L7 14V24V34L15.5 39L24 44L32.5001 39L41 34V24V14L32.5001 9L24 4L15.5 9Z",
    stroke: "url(#paint0_linear_1149_925)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4V24",
    stroke: "url(#paint1_linear_1149_925)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 34L24 24",
    stroke: "url(#paint2_linear_1149_925)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 34L24 24",
    stroke: "url(#paint3_linear_1149_925)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44V34",
    stroke: "url(#paint4_linear_1149_925)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 14L33 19",
    stroke: "url(#paint5_linear_1149_925)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14L15 19",
    stroke: "url(#paint6_linear_1149_925)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7614 31V16.4545H62.6761C63.8172 16.4545 64.75 16.6605 65.4744 17.0724C66.2036 17.4796 66.7434 18.0312 67.0938 18.7273C67.4441 19.4233 67.6193 20.1998 67.6193 21.0568C67.6193 21.9138 67.4441 22.6927 67.0938 23.3935C66.7481 24.0942 66.2131 24.6529 65.4886 25.0696C64.7642 25.4815 63.8362 25.6875 62.7045 25.6875H59.1818V24.125H62.6477C63.429 24.125 64.0563 23.9901 64.5298 23.7202C65.0033 23.4503 65.3466 23.0857 65.5597 22.6264C65.7775 22.1624 65.8864 21.6392 65.8864 21.0568C65.8864 20.4744 65.7775 19.9536 65.5597 19.4943C65.3466 19.035 65.0009 18.6752 64.5227 18.4148C64.0445 18.1496 63.41 18.017 62.6193 18.017H59.5227V31H57.7614ZM70.2294 31V20.0909H71.9055V31H70.2294ZM71.0817 18.2727C70.755 18.2727 70.4732 18.1615 70.2365 17.9389C70.0045 17.7164 69.8885 17.4489 69.8885 17.1364C69.8885 16.8239 70.0045 16.5563 70.2365 16.3338C70.4732 16.1113 70.755 16 71.0817 16C71.4084 16 71.6877 16.1113 71.9197 16.3338C72.1565 16.5563 72.2749 16.8239 72.2749 17.1364C72.2749 17.4489 72.1565 17.7164 71.9197 17.9389C71.6877 18.1615 71.4084 18.2727 71.0817 18.2727ZM83.896 20.0909L79.8619 31H78.1573L74.1232 20.0909H75.9414L78.9528 28.7841H79.0664L82.0778 20.0909H83.896ZM90.1495 31.2273C89.1647 31.2273 88.3005 30.9929 87.5572 30.5241C86.8185 30.0554 86.2409 29.3996 85.8242 28.5568C85.4123 27.714 85.2063 26.7292 85.2063 25.6023C85.2063 24.4659 85.4123 23.474 85.8242 22.6264C86.2409 21.7789 86.8185 21.1207 87.5572 20.652C88.3005 20.1832 89.1647 19.9489 90.1495 19.9489C91.1344 19.9489 91.9961 20.1832 92.7347 20.652C93.4781 21.1207 94.0558 21.7789 94.4677 22.6264C94.8844 23.474 95.0927 24.4659 95.0927 25.6023C95.0927 26.7292 94.8844 27.714 94.4677 28.5568C94.0558 29.3996 93.4781 30.0554 92.7347 30.5241C91.9961 30.9929 91.1344 31.2273 90.1495 31.2273ZM90.1495 29.7216C90.8976 29.7216 91.5131 29.5298 91.9961 29.1463C92.479 28.7628 92.8365 28.2585 93.0685 27.6335C93.3005 27.0085 93.4165 26.3314 93.4165 25.6023C93.4165 24.8731 93.3005 24.1937 93.0685 23.5639C92.8365 22.9342 92.479 22.4252 91.9961 22.0369C91.5131 21.6487 90.8976 21.4545 90.1495 21.4545C89.4014 21.4545 88.7859 21.6487 88.3029 22.0369C87.82 22.4252 87.4625 22.9342 87.2305 23.5639C86.9985 24.1937 86.8825 24.8731 86.8825 25.6023C86.8825 26.3314 86.9985 27.0085 87.2305 27.6335C87.4625 28.2585 87.82 28.7628 88.3029 29.1463C88.7859 29.5298 89.4014 29.7216 90.1495 29.7216ZM102.396 20.0909V21.5114H96.7422V20.0909H102.396ZM98.3899 17.4773H100.066V27.875C100.066 28.3485 100.135 28.7036 100.272 28.9403C100.414 29.1723 100.594 29.3286 100.812 29.4091C101.034 29.4848 101.269 29.5227 101.515 29.5227C101.7 29.5227 101.851 29.5133 101.969 29.4943C102.088 29.4706 102.183 29.4517 102.254 29.4375L102.594 30.9432C102.481 30.9858 102.322 31.0284 102.119 31.071C101.915 31.1184 101.657 31.142 101.344 31.142C100.871 31.142 100.407 31.0402 99.9524 30.8366C99.5026 30.633 99.1286 30.3229 98.8303 29.9062C98.5367 29.4896 98.3899 28.964 98.3899 28.3295V17.4773ZM109.661 20.0909V21.5114H104.008V20.0909H109.661ZM105.656 17.4773H107.332V27.875C107.332 28.3485 107.4 28.7036 107.538 28.9403C107.68 29.1723 107.86 29.3286 108.077 29.4091C108.3 29.4848 108.534 29.5227 108.781 29.5227C108.965 29.5227 109.117 29.5133 109.235 29.4943C109.353 29.4706 109.448 29.4517 109.519 29.4375L109.86 30.9432C109.746 30.9858 109.588 31.0284 109.384 31.071C109.181 31.1184 108.923 31.142 108.61 31.142C108.137 31.142 107.673 31.0402 107.218 30.8366C106.768 30.633 106.394 30.3229 106.096 29.9062C105.802 29.4896 105.656 28.964 105.656 28.3295V17.4773ZM113.404 31.1136C113.054 31.1136 112.753 30.9882 112.502 30.7372C112.251 30.4863 112.126 30.1856 112.126 29.8352C112.126 29.4848 112.251 29.1842 112.502 28.9332C112.753 28.6823 113.054 28.5568 113.404 28.5568C113.754 28.5568 114.055 28.6823 114.306 28.9332C114.557 29.1842 114.683 29.4848 114.683 29.8352C114.683 30.0672 114.623 30.2803 114.505 30.4744C114.391 30.6686 114.237 30.8248 114.043 30.9432C113.854 31.0568 113.641 31.1136 113.404 31.1136ZM120.901 31.2557C120.209 31.2557 119.582 31.1255 119.018 30.8651C118.455 30.5999 118.008 30.2188 117.676 29.7216C117.345 29.2197 117.179 28.6136 117.179 27.9034C117.179 27.2784 117.302 26.7718 117.548 26.3835C117.795 25.9905 118.124 25.6828 118.536 25.4602C118.947 25.2377 119.402 25.072 119.899 24.9631C120.401 24.8494 120.905 24.7595 121.412 24.6932C122.075 24.608 122.612 24.544 123.024 24.5014C123.441 24.4541 123.744 24.3759 123.933 24.267C124.127 24.1581 124.224 23.9687 124.224 23.6989V23.642C124.224 22.9413 124.033 22.3968 123.649 22.0085C123.27 21.6203 122.695 21.4261 121.923 21.4261C121.123 21.4261 120.496 21.6013 120.041 21.9517C119.587 22.3021 119.267 22.6761 119.082 23.0739L117.491 22.5057C117.776 21.8428 118.154 21.3267 118.628 20.9574C119.106 20.5833 119.627 20.3229 120.19 20.1761C120.759 20.0246 121.317 19.9489 121.866 19.9489C122.217 19.9489 122.619 19.9915 123.074 20.0767C123.533 20.1572 123.976 20.3253 124.402 20.581C124.833 20.8366 125.19 21.2225 125.474 21.7386C125.759 22.2547 125.901 22.946 125.901 23.8125V31H124.224V29.5227H124.139C124.026 29.7595 123.836 30.0128 123.571 30.2827C123.306 30.5526 122.953 30.7822 122.513 30.9716C122.072 31.161 121.535 31.2557 120.901 31.2557ZM121.156 29.75C121.819 29.75 122.378 29.6198 122.832 29.3594C123.292 29.099 123.637 28.7628 123.869 28.3509C124.106 27.9389 124.224 27.5057 124.224 27.0511V25.517C124.153 25.6023 123.997 25.6804 123.756 25.7514C123.519 25.8177 123.244 25.8769 122.932 25.929C122.624 25.9763 122.323 26.0189 122.03 26.0568C121.741 26.09 121.507 26.1184 121.327 26.142C120.891 26.1989 120.484 26.2912 120.105 26.419C119.731 26.5421 119.428 26.7292 119.196 26.9801C118.969 27.2263 118.855 27.5625 118.855 27.9886C118.855 28.571 119.071 29.0114 119.501 29.3097C119.937 29.6032 120.489 29.75 121.156 29.75ZM128.96 31V20.0909H130.636V31H128.96ZM129.812 18.2727C129.485 18.2727 129.204 18.1615 128.967 17.9389C128.735 17.7164 128.619 17.4489 128.619 17.1364C128.619 16.8239 128.735 16.5563 128.967 16.3338C129.204 16.1113 129.485 16 129.812 16C130.139 16 130.418 16.1113 130.65 16.3338C130.887 16.5563 131.005 16.8239 131.005 17.1364C131.005 17.4489 130.887 17.7164 130.65 17.9389C130.418 18.1615 130.139 18.2727 129.812 18.2727Z",
    fill: "#191A47"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1149_925",
    x1: 24,
    y1: 4,
    x2: 24,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1149_925",
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1149_925",
    x1: 32.5,
    y1: 24,
    x2: 32.5,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1149_925",
    x1: 15.5,
    y1: 24,
    x2: 15.5,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1149_925",
    x1: 24.5,
    y1: 34,
    x2: 24.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1149_925",
    x1: 37,
    y1: 14,
    x2: 37,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1149_925",
    x1: 11,
    y1: 14,
    x2: 11,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBluev);
export default __webpack_public_path__ + "static/media/logo_bluev.00fc4a2cf7f018ecf3856f58246b4270.svg";
export { ForwardRef as ReactComponent };